var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    ref: "contentBox",
    staticClass: "clearfix",
    class: {
      fullScreen: _vm.pipsListFullScreen,
      notShowFootBar: !_vm.State.showFootBar,
      onlyMainWindow: _vm.allRtilList.length == 1
    }
  }, [_c('div', {
    staticClass: "contentBox",
    class: {
      showChat: _vm.State.showChatMessage
    }
  }, [_c('div', {
    staticClass: "hide"
  }, [_vm._v(_vm._s(_vm.allRtilList) + "," + _vm._s(_vm.behaviorInfo) + "，" + _vm._s(_vm.blockVideoObj) + "," + _vm._s(_vm.outputRtilCode))]), _vm.pipsListFullScreen ? _c('div', {
    staticClass: "closeBtn",
    on: {
      "mouseenter": function ($event) {
        return _vm.showFullScreenCloseBtnFn(true);
      },
      "mouseleave": function ($event) {
        return _vm.showFullScreenCloseBtnFn(false);
      }
    }
  }, [_c('div', {
    staticClass: "common"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCloseFullScreenBtn,
      expression: "showCloseFullScreenBtn"
    }],
    on: {
      "click": function ($event) {
        _vm.pipsListFullScreen = false;
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-error"
  }), _vm._v(_vm._s(_vm.$t('kioskHost.exitFullScreen')))])])]) : _vm._e(), _c('div', {
    staticClass: "hide",
    staticStyle: {
      "position": "absolute",
      "z-index": "100",
      "top": "70px"
    }
  }, [_vm._v(_vm._s(_vm.allRtilList) + ",outputRtilCode:" + _vm._s(_vm.outputRtilCode) + ",outputRtilList:" + _vm._s(_vm.outputRtilList))]), _c('div', {
    staticClass: "pipList",
    class: {
      showChat: _vm.State.showChatMessage
    }
  }, [_c('participateList', {
    ref: "pipListBox",
    class: {
      showMuteIcons: _vm.showMuteIcons
    },
    attrs: {
      "shareList": _vm.shareList,
      "rtilList": _vm.allRtilList,
      "behaviorInfo": _vm.behaviorInfo,
      "streamInfo": _vm.channels,
      "outputRtilCode": _vm.outputRtilCode,
      "outputRtilList": _vm.outputRtilList,
      "userInfo": _vm.userInfo,
      "isAudioLevel": _vm.isAudioLevel,
      "fullScreen": _vm.pipsListFullScreen,
      "outputSourceType": _vm.outputSourceType,
      "degreeHost": _vm.degreeHost,
      "showChatMessage": _vm.State.showChatMessage,
      "rtc": _vm.rtc,
      "cameraStatus": _vm.State.cameraStatus,
      "micStatus": _vm.State.micStatus,
      "remoteNetWorks": _vm.remoteNetWorks,
      "showPipCursorPointer": _vm.showPipCursorPointer,
      "showMuteIcons": _vm.showMuteIcons
    },
    on: {
      "callback": _vm.attendCallback
    },
    scopedSlots: _vm._u([{
      key: "localStream",
      fn: function () {
        return [_c('NewAttendUser', {
          ref: "localVideo",
          staticClass: "is-local",
          class: {
            'bitrate8-9': _vm.outputRtilList.filter(v => v.rtilCode == _vm.userInfo.rtilCode).length
          },
          attrs: {
            "isAudioLevel": _vm.isAudioLevel,
            "singChannel": {
              id: _vm.userInfo.rtilCode,
              channel: _vm.partyCode,
              audioTrack: _vm.rtc[_vm.realPartyCode]._localAudioTrack,
              videoTrack: _vm.rtc[_vm.realPartyCode]._localVideoTrack
            },
            "title": "Me",
            "nickName": _vm.behaviorInfo[_vm.userInfo.rtilCode],
            "userInfo": _vm.userInfo,
            "degreeHost": _vm.degreeHost[_vm.userInfo.rtilCode],
            "muteVideo": !_vm.State.cameraStatus[_vm.userInfo.rtilCode],
            "muteAudio": !_vm.State.micStatus[_vm.userInfo.rtilCode],
            "operateList": _vm.operateList,
            "lockName": _vm.lockName,
            "rtc": _vm.rtc[_vm.partyCode],
            "outputRtilCode": _vm.outputRtilCode,
            "volume": _vm.voiceList[_vm.userInfo.rtilCode],
            "showMuteIcons": _vm.showMuteIcons
          },
          on: {
            "callback": _vm.attendCallback
          }
        }, [_c('div', {
          staticClass: "localVideo",
          class: _vm.returnVideoClass,
          attrs: {
            "id": "local_stream"
          }
        })])];
      },
      proxy: true
    }, {
      key: "rightBox",
      fn: function () {
        return [_c('PictureRightAside', {
          ref: "rightAside",
          attrs: {
            "firstLogoList": _vm.firstLogoList
          },
          on: {
            "callBack": _vm.changeLogo
          }
        })];
      },
      proxy: true
    }])
  })], 1), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hostStream hide"
  }, _vm._l(_vm.userInfo.managerRtils, function (val) {
    return _c('div', {
      key: val,
      staticClass: "item"
    }, [_vm.channels[val] ? _c('NewAttendUser', {
      ref: `remoteHost${val}`,
      refInFor: true,
      staticClass: "is-host",
      class: {
        notShowFootBar: !_vm.State.showFootBar
      },
      attrs: {
        "singChannel": _vm.channels[val],
        "title": "host",
        "isAudioLevel": _vm.isAudioLevel,
        "muteVideo": !_vm.State.cameraStatus[val],
        "muteAudio": !_vm.State.micStatus[val],
        "userInfo": _vm.userInfo,
        "rtc": _vm.rtc[_vm.realPartyCode]
      }
    }) : _vm._e()], 1);
  }), 0)], 1), _c('TipsDailog', {
    attrs: {
      "info": _vm.CameraTips,
      "showClose": false
    },
    on: {
      "save": _vm.setCameraStatus,
      "cancel": () => {
        _vm.sendToHost('camera', 2);
      }
    }
  }), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])]), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _vm.userInfo.rtilCode ? _c('div', {
    staticClass: "chatBox"
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.showChatMessage,
      expression: "State.showChatMessage"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "showComponent": _vm.State.showChatMessage,
      "nickNameInfo": _vm.behaviorInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _c('Foot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.pipsListFullScreen,
      expression: "!pipsListFullScreen"
    }],
    attrs: {
      "camera": _vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "showUnread": _vm.showUnread,
      "rtcLoaded": _vm.rtcLoaded,
      "userInfo": _vm.userInfo,
      "devicesInfo": _vm.devicesInfo,
      "showChat": _vm.State.showChatMessage,
      "pipsListFullScreen": _vm.pipsListFullScreen,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "cameraDevice": _vm.devicesInfo.cameraList,
      "showIconArray": ['leaveParty', 'camera', 'mic', 'speaker', 'chat', 'fullScreen'],
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc[_vm.realPartyCode],
      "showPipFullScreen": _vm.showPipFullScreen
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };